
const Events = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-8 lg:p-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Special <span className="text-yellow-600">Events & Projects</span>
              </h2>
              <p className="text-lg text-gray-600 mb-6">
                Planning a special event or large-scale electrical project? OhmEx Electric provides 
                comprehensive electrical solutions for events, renovations, and commercial projects 
                throughout the GTA area.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-500 text-xl"></i>
                  <span className="text-gray-700">Event electrical setup and breakdown</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-500 text-xl"></i>
                  <span className="text-gray-700">Temporary power solutions</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-500 text-xl"></i>
                  <span className="text-gray-700">Large-scale renovation electrical work</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-green-500 text-xl"></i>
                  <span className="text-gray-700">Commercial electrical installations</span>
                </div>
              </div>
              <a
                href="https://wa.me/16472873597?text=Hi%20Volt%20Electric!%20I%20would%20like%20to%20request%20a%20quote%20for%20a%20special%20event%20or%20project."
                className="bg-yellow-400 text-black px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-500 transition-colors cursor-pointer whitespace-nowrap inline-flex items-center space-x-2"
              >
                <i className="ri-whatsapp-fill"></i>
                <span>Request Quote</span>
              </a>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/80b5d9d2f07f871e5d3748fb75094810.jpg"
                alt="Special Events & Projects"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-black/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;
